import { Attribute, Directive, Input, TemplateRef } from "@angular/core";
import { IconName } from "@dtm-frontend/shared/ui";

@Directive({
    selector: "[dtmMapLayersWithControlsCustomElement]",
})
export class DtmMapLayersWithControlsCustomElementDirective {
    @Input({ required: true }) public name!: string;
    @Input({ required: true }) public panelKey!: string;
    constructor(@Attribute("icon") public icon: IconName, public template: TemplateRef<{ isOpened: true }>) {}
}
